module.exports = __webpack_public_path__ + "socials.svg?d757699f4da096bafb24f8360968eb28";